import bottlecrackssteam from "../assets/bottlecracks_steam.png"
import bcs1 from "../assets/portfolio_imgs/bc_steam1.webp"
import bcs2 from "../assets/portfolio_imgs/bc_steam2.webp"
import bcs3 from "../assets/portfolio_imgs/bc_steam3.webp"
import bcs4 from "../assets/portfolio_imgs/bc_steam4.webp"
import bcs5 from "../assets/portfolio_imgs/bc_steam5.webp"
import bcs6 from "../assets/portfolio_imgs/bc_steam6.webp"
import bcs7 from "../assets/portfolio_imgs/bc_steam7.webp"
import bcs8 from "../assets/portfolio_imgs/bc_steam8.webp"

import slimeblock from "../assets/slimeblock.png"
import sb1 from "../assets/portfolio_imgs/sb1.webp"
import sb2 from "../assets/portfolio_imgs/sb2.webp"
import sb3 from "../assets/portfolio_imgs/sb3.webp"
import sb4 from "../assets/portfolio_imgs/sb4.webp"
import sb5 from "../assets/portfolio_imgs/sb5.webp"

import minematch from "../assets/minematch.jpg"
import mm1 from "../assets/portfolio_imgs/mm1.webp"
import mm2 from "../assets/portfolio_imgs/mm2.webp"
import mm3 from "../assets/portfolio_imgs/mm3.webp"
import mm4 from "../assets/portfolio_imgs/mm4.webp"

import nethermonsters from "../assets/nethermonsters.jpg"
import nm1 from "../assets/portfolio_imgs/nm1.webp"
import nm2 from "../assets/portfolio_imgs/nm2.webp"
import nm3 from "../assets/portfolio_imgs/nm3.webp"
import nm4 from "../assets/portfolio_imgs/nm4.webp"
import nm5 from "../assets/portfolio_imgs/nm5.webp"

import netherDungeons from "../assets/netherdungeons.jpg"
import nd1 from "../assets/portfolio_imgs/nd1.jpg"
import nd2 from "../assets/portfolio_imgs/nd2.jpg"
import nd3 from "../assets/portfolio_imgs/nd3.jpg"
import nd4 from "../assets/portfolio_imgs/nd4.jpg"
import nd5 from "../assets/portfolio_imgs/nd5.jpg"

import awitaDuo from "../assets/awitaduo_front.jpg"
import aw1 from "../assets/portfolio_imgs/aw1.jpg"
import aw2 from "../assets/portfolio_imgs/aw2.jpg"
import aw3 from "../assets/portfolio_imgs/aw3.jpg"
import aw4 from "../assets/portfolio_imgs/aw4.jpg"

import turboAmigo from "../assets/turboamigo_front.jpg"
import ta1 from "../assets/portfolio_imgs/ta1.jpg"
import ta2 from "../assets/portfolio_imgs/ta2.jpg"
import ta3 from "../assets/portfolio_imgs/ta3.jpg"
import ta4 from "../assets/portfolio_imgs/ta4.jpg"
import ta5 from "../assets/portfolio_imgs/ta5.jpg"

import bottleCracks from "../assets/bottlecracks_front.jpg"
import bc1 from "../assets/portfolio_imgs/bc1.jpg"
import bc2 from "../assets/portfolio_imgs/bc2.jpg"
import bc3 from "../assets/portfolio_imgs/bc3.jpg"

import dungeontime from "../assets/dungeontime_front.jpg"
import dt1 from "../assets/portfolio_imgs/dt1.jpg"
import dt2 from "../assets/portfolio_imgs/dt2.jpg"
import dt3 from "../assets/portfolio_imgs/dt3.jpg"
import dt4 from "../assets/portfolio_imgs/dt4.jpg"

import wijiWaji from "../assets/wijiwaji_front.jpg"
import ww1 from "../assets/portfolio_imgs/ww1.jpg"
import ww2 from "../assets/portfolio_imgs/ww2.jpg"
import ww3 from "../assets/portfolio_imgs/ww3.jpg"
import ww4 from "../assets/portfolio_imgs/ww4.jpg"
import ww5 from "../assets/portfolio_imgs/ww5.jpg"

import bugsNBog from "../assets/bugsnbog_front.jpg"
import bnb1 from "../assets/portfolio_imgs/bnb1.jpg"
import bnb2 from "../assets/portfolio_imgs/bnb2.jpg"
import bnb3 from "../assets/portfolio_imgs/bnb3.jpg"
import bnb4 from "../assets/portfolio_imgs/bnb4.jpg"

import labotrain from "../assets/labotrain_front.jpg"
import lt1 from "../assets/portfolio_imgs/lt1.jpg"
import lt2 from "../assets/portfolio_imgs/lt2.jpg"
import lt3 from "../assets/portfolio_imgs/lt3.jpg"



export const portfolioData = [
    {
        id:"bottle-cracks-steam",
        title:"Bottle Cracks",
        description:"Party game where everyone is a bottle. Jump through chaotic levels without breaking! Play solo, online with up to 12 players, or with unlimited local players.",
        imgDir:bottlecrackssteam,
        youtubeID: "AWX1GUdVtgM",
        prevImgs: 
        [
            bcs1,
            bcs2,
            bcs3,
            bcs4,   
            bcs5,   
            bcs6,   
            bcs7,   
            bcs8   
        ],
        factsData:{
            "Project Type": "Personal",
            "Software Used": "Unity",
            "Languages Used": "C#",      
            "Primary Role(s)": "Solo Developer"
        },
        fullDescription:"Bottle Cracks is my first game released on Steam! For this project, I created a party game where players control bottles and compete in chaotic physics-based level. If you collide with too much force, your bottle cracks!\n\nThe idea came from the great support the game received from the early version I released on itch.io, which motivated me to expand the project into a full Steam release.",
        pages:
        {
            "STEAM PAGE": "https://store.steampowered.com/app/3982830/Bottle_Cracks/"
        }
    },
    {
        id:"minematch",
        title: "Mine Match",
        description: "Online multiplayer party game, where friends and players worldwide join live rooms to compete in fast-paced, clever minigames with voice and text chat for a truly social experience.",
        imgDir: minematch,
        youtubeID: "",
        prevImgs: [
            mm1,
            mm2,
            mm3,
            mm4
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Unity, Git, Notion",
            "Languages Used": "C#",      
            "Primary Role(s)": "Gameplay & Backend Programmer, Project Manager"
        },
        fullDescription: "Mine Match is the ultimate online multiplayer party game, bringing friends and players from around the world together in live rooms to compete in fast-paced, fun, and clever minigames. Whether players enjoy guessing games or quick-decision challenges, Mine Match delivers an energetic and social experience with integrated voice and text chat.\n\nI contributed as a programmer, working both on Unity and the backend. I developed the multiplayer server using WebSockets with .NET, implementing features according to specific requirements, including bot AI ranging from simple actions to chat responses powered by AI in one of the minigames.\n\nIn addition to programming, I took on project management responsibilities, maintaining constant communication with the streamer, coordinating with other programmers, and improving development workflows. I also created the full documentation for the multiplayer service I implemented and guided the team on its usage.",
        pages:{
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.MineMatch",
            "APP STORE": "https://apps.apple.com/us/app/mine-match-multiplayer-games/id6746417320"
        }
    },
    {
        id:"slimeblock",
        title: "Slimeblock.io",
        description: "Exciting .io game where you control a slime block, absorb everything in your path, and compete against other slimes to become the ultimate super slime.",
        imgDir: slimeblock,
        youtubeID: "cEVL_nNdA9o",
        prevImgs: [
            sb1,
            sb2,
            sb3,
            sb4,
            sb5
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Notion",
            "Primary Role(s)": "Project Manager"
        },
        fullDescription: "Slimeblock.io is a thrilling 3D .io game where players control a slime block, absorbing objects and opponents to grow larger and more powerful. Compete against other slimes and climb the leaderboard to become the ultimate super slime.\n\nI contributed exclusively as Project Manager, overseeing development iterations and ensuring smooth communication with English-speaking streamers. We maintained friendly and continuous collaboration, gathering feedback to guide the game's evolution. The team worked in an Agile framework, using Scrum with Kanban to organize sprints, prioritize tasks, and deliver updates efficiently.",
        pages:{
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.Slimeblock",
            "APP STORE": "https://apps.apple.com/us/app/slimeblock-io/id6744073207"
        }
    },
    {
        id:"nether-monsters",
        title: "Nether Monsters",
        description: "Fast-paced Survivor action with Monster Tamer mechanics, building and evolving a team of powerful NETHERMONS.",
        imgDir: nethermonsters,
        youtubeID: "1kkcsaKQcYk",
        prevImgs: [
            nm1,
            nm2,
            nm3,
            nm4,
            nm5
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Unity, Git, Notion",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer, Project Manager"
        },
        fullDescription: "Nether Monsters combines fast-paced Survivor-style action with the depth of a Monster Tamer experience. Players battle through relentless waves of enemies while forming and evolving a team of powerful creatures known as NETHERMONS, each possessing unique elemental abilities that shape combat strategies.\n\nI contributed as a programmer, collaborating closely with a team of developers from Arakuma Studio to bring the game to life. My primary responsibilities included optimizing the movement of numerous entities—a critical challenge given the large number of enemies on screen at once, similar to Vampire Survivors. Instead of relying on Unity’s default collision system, I implemented a custom grid-based system to handle interactions more efficiently, significantly improving performance.\n\nIn addition to programming, I also took on project management responsibilities, streamlining workflows, improving team efficiency, and ensuring smooth collaboration throughout development.",
        pages:{
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.NetherMonsters",
            "APP STORE": "https://apps.apple.com/us/app/nether-monsters/id6742568029"
        }
    },
    {
        id:"nether-dungeons",
        title: "Nether Dungeons",
        description: "Action-packed dungeon crawler. Battle through procedurally generated dungeons, face relentless enemies, and defeat epic bosses.",
        imgDir: netherDungeons,
        youtubeID: "drajw6QvoGA",
        prevImgs: [
            nd1,
            nd2,
            nd3,
            nd4,
            nd5
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Unity, Git",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "Nether Dungeons is an action-packed dungeon crawler. Battle through procedurally generated dungeons, face relentless enemies, and defeat epic bosses. Customize your hero, wield diverse weapons, and survive intense challenges as you descend into ever-changing, dangerous depths.\n\nI contributed to the development of this game for approximately one year at Arakuma Studio as a programmer. I worked closely with a team of talented programmers and artists. Additionally, we collaborated with Farfadox, a YouTuber with over 3 million subscribers, to help bring his vision for the game to life.",
        pages:{
            "STEAM PAGE": "https://store.steampowered.com/app/3096270/NETHER_DUNGEONS/",
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.NetherDungeons",
            "APP STORE": "https://apps.apple.com/us/app/nether-dungeons/id6737908225"
        }
    },
    {
        id:"awita-duo-elemental",
        title: "Awita: Duo Elemental",
        description: "With the company of Awita's unique characters, explore fascinating biomes and solve clever puzzles.",
        imgDir: awitaDuo,
        youtubeID: "4xXoXnvBODw",
        prevImgs: [
            aw1,
            aw2,
            aw3,
            aw4
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Unity, Git",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "Awita: Elemental Duo is a platformer puzzle game where the player must switch between two characters to solve each level using their unique abilities\n\nThis game was developed in collaboration with other talented programmers and artists at Arakuma Studio.",
        pages:{
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.AwitaGame",
            "APP STORE": "https://apps.apple.com/pe/app/awita-duo-elemental/id6478712744"
        }
    },
    {
        id:"turbo-amigo",
        title: "Turbo Amigo",
        description: "Take care of Turbo, your virtual pet, and embark on a journey full of fun and games! Feed, clean, and keep Turbo healthy.",
        imgDir: turboAmigo,
        youtubeID: "uNlyHZeauDw",
        prevImgs: [
            ta1,
            ta2,
            ta3,
            ta4,
            ta5
        ],
        factsData:{
            "Project Type": "Work project",
            "Software Used": "Unity, Git",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "Turbo Amigo is a virtual pet game where you must take care of Turbo, your new friend. Feed, clean, and keep Turbo healthy to unlock new games and activities.\n\nThis game was developed in collaboration with other talented programmers and artists at Arakuma Studio. We also worked with xTurbo, a YouTuber with over 6 million subscribers, to create the game he envisioned.",
        pages:{
            "GOOGLE PLAY": "https://play.google.com/store/apps/details?id=com.ArakumaStudio.TurboAmigo",
            "APP STORE": "https://apps.apple.com/pe/app/turbo-amigo/id6474603038"
        }
    },
    {
        id:"bottle-cracks",
        title: "Bottle Cracks!",
        description: "Cooperative multiplayer game, playable locally and online. Choose just one key and jump to the end without your bottle cracking!",
        imgDir: bottleCracks,
        youtubeID: "GhoOBoZ5CAI",
        prevImgs: [
            bc1,
            bc2,
            bc3
        ],
        factsData:{
            "Project Type": "Personal",
            "Software Used": "Unity, Photon Pun",
            "Languages Used": "C#",      
            "Primary Role(s)": "Solo Developer"
        },
        fullDescription: "Bottle Cracks! is my second online multiplayer game, designed for up to 16 players. The game's concept revolves around guiding a bottle to the end of each level using only a single key to make it jump. However, it's important to be careful with the applied force, as the bottle can crack if too much force is used.\n\nThe idea for this game came to me when I challenged myself to create a game for a sleepover event taking place in just two weeks. The challenge was that we had six people but only one keyboard. Consequently, I had to come up with a game that allowed each character to control a bottle using only one key.\n\nTo develop Bottle Cracks!, I drew inspiration from various games such as Getting Over It with Bennett Foddy, Golfin Over It, Golf With Friends, and Jump King. Initially, the game could only be played locally, but after a few weeks, I managed to implement online gameplay. I continue to update the game periodically, and it has received great acclaim from players.\n\nMy future plans for Bottle Cracks! involve enhancing and completely redesigning the game with the intention of releasing it on the Steam platform. I am excited about the possibilities this represents and look forward to offering an even more captivating experience for players.",
        pages:{
            "STEAM PAGE": "https://store.steampowered.com/app/3982830/Bottle_Cracks/",
            "ITCH.IO PAGE": "https://frowsyfrog.itch.io/bottle-cracks"
        }
    },
    {
        id:"here-comes-the-wiji-waji",
        title: "Here Comes The Wiji Waji",
        description: "Online multiplayer game. Several creatures went to a Playground, and one of them is the Wiji Waji, who is blood thirsty.",
        imgDir: wijiWaji,
        youtubeID: "1QO-nBrzoM8",
        prevImgs: [
            ww1,
            ww2,
            ww3,
            ww4,
            ww5
        ],
        factsData:{
            "Project Type": "Personal",
            "Software Used": "Unity, Photon Pun",
            "Languages Used": "C#",      
            "Primary Role(s)": "Solo Developer"
        },
        fullDescription: "Here Comes The Wiji Waji was my first online multiplayer game project. The premise of the game is that several creatures gather in a Playground, and among them is the Wiji Waji, whose objective is to kill the other players. Participants must collect artifacts to unlock a gun, and giving them the opportunity to defeat the Wiji Waji.\n\nI developed this game with the purpose of learning to program an online multiplayer game and also to have something to play with my friends. I focused on programming, sound design, and character modeling, while the 3D models of the environment were obtained through free assets.\n\nWhen creating this game, I was inspired by three titles: 'Escape the Beast', a Minecraft minigame, and 'Murder Mystery 2', from Roblox.   ",
        pages:{
            "ITCH.IO PAGE": "https://frowsyfrog.itch.io/here-comes-the-wiji-waji"
        }
    },
    {
        id:"dungeon-time",
        title: "The Dungeon of Time",
        description: "Game made for a 2-day game jam that I did as part of a team. Go through the 3 rooms of the dungeon without getting caught!",
        imgDir: dungeontime,
        youtubeID: "QfoOCvpLdrQ",
        prevImgs: [
            dt1,
            dt2,
            dt3,
            dt4
        ],
        factsData:{
            "Project Type": "GameJam / group project",
            "Software Used": "Unity",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "Delve into The Dungeon of Time, a mesmerizing PSX-inspired roguelike game crafted by a team of six for the UPC 2023 game jam. Play as a time-manipulating magician and navigate three rooms guarded by creatures. Your task? Race against time to conquer each room as quickly as possible. Can you master temporal magic and emerge victorious in this challenging adventure?",
        pages:{
            "ITCH.IO PAGE": "https://salador.itch.io/the-dungeon-of-time"
        }
    },
    {
        id:"bugs-n-bog",
        title: "Bugs 'n Bog",
        description: "Game made for a 3-day game jam that I did as part of a team. Play as a frog waiter, serve your best and maintain a 5-star reputation.",
        imgDir: bugsNBog,
        youtubeID: "VRU_z8a-gtY",
        prevImgs: [
            bnb1,
            bnb2,
            bnb3,
            bnb4
        ],
        factsData:{
            "Project Type": "GameJam / group project",
            "Software Used": "Unity",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "Bugs 'n Bog was a game I developed in just 72 hours, assuming the role of a programmer within a team. The game revolves around being a frog waiter responsible for serving all the customers to maintain the restaurant's 5-star reputation.\n\nParticipating in this project was an incredibly enriching experience. I really enjoyed the process of getting to know our team better by participating in various icebreaker games. Subsequently, we brainstormed and organized effectively, resulting in a very enjoyable and successful development experience.",
        pages:{
            "ITCH.IO PAGE": "https://triplecatgames.itch.io/bugs-n-bog"
        }
    },
    {
        id:"labotrain",
        title: "LaboTrain",
        description: "University project using Artificial Intelligence techniques. Compete in a race against an AI opponent in 5 procedurally generated mazes.",
        imgDir: labotrain,
        youtubeID: "Pitb6qiQ5rA",
        prevImgs:[
            lt1,
            lt2,
            lt3
        ],
        factsData:{
            "Project Type": "University project",
            "Software Used": "Unity",
            "Languages Used": "C#",      
            "Primary Role(s)": "Programmer"
        },
        fullDescription: "LaboTrain is a university project developed in just one day. It challenges you to race against an artificial intelligence through 5 procedurally generated mazes. Move your character and reach the treasure chest. If the AI manages to exit the maze before you do, you will lose.\n\nThis project was created to apply knowledge of artificial intelligence, both for maze generation and enemy pathfinding within the game. The project is completely open-source, allowing anyone to edit the game to their liking and explore its inner workings.",
        pages:{
            "GITHUB PAGE": "https://github.com/FrowsyFrog/LaboTrain"
        }
    }
]